import moment from 'moment'
import ft from '../featureToggle'

export default {
  getList (VueApp, callback) {
    let self = this
    let provider = VueApp.$store.state.provider
    let availability = provider.availability
    let param = {
      token: VueApp.$store.state.session.sessionToken,
      vehicleType: null,
      pageNum: availability.currentPage,
      pageSize: availability.perPage,
      order: availability.order,
      orderAsc: availability.orderAsc,
      sectorId: availability.sector,
      since: availability.since,
      until: availability.until
    }

    // param.until = moment(availability.until, 'X').add(1, 'hours').format('X')

    if (availability.service) {
      switch (availability.service) {
        case 'PAX':
          param.isPax = 1
          param.isDTD = 0
        break
        case 'DTD':
          param.isPax = 0
          param.isDTD = 1
        break
        case 'PAX/DTD':
          param.isPax = 1
          param.isDTD = 1
        break
      }
    }

    if (availability.type) param.licenseType = availability.type
    if (availability.vehicleType) param.vehicleType = availability.vehicleType
    if (availability.assignedTrips) param.assignments = availability.assignedTrips

    VueApp.$store.commit('provider/setAvailabilityChecked', [])
    VueApp.$sdk.get('/shifts/dashboard', param, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setAvailabilityMaxList', res.paging.totalItems)

        if (res.list.length) {
          let provs = []
          res.list.forEach(function (prov) {
            let name = prov.businessName || `${prov.firstName} ${prov.lastName}`
            let availableFrom = ''
            let availableUntil = ''
            if (prov.startTimestamp) {
              let sinceTime = moment(availability.since, 'X').format(ft.timeFormat(VueApp, false))
              // availableFrom = moment(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
              availableFrom = moment(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
              availableUntil = moment(prov.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
            }
            if (prov.rsvpTimestamp) {
              availableFrom = moment(prov.rsvpTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
              availableUntil = moment(prov.rsvpTimestamp, 'YYYY-MM-DD HH:mm').add(12, 'hours').format('MM/DD/YYYY hh:mmA')
            }
            let paxDtd = ''
            if (prov.supportPax) {
              paxDtd = 'PAX'
            }
            if (prov.supportDTD) {
              paxDtd = 'DTD'
            }
            if (prov.supportPax && prov.supportDTD) {
              paxDtd = 'PAX/DTD'
            }
            provs.push({
              id: prov.ID,
              name: name,
              firstName: prov.firstName,
              lastName: prov.lastName,
              licenseType: prov.accountType,
              homeSector: prov.homeSectorName || '',
              paxDtd: paxDtd,
              vehicleType: prov.vehicleType || '',
              availableFrom: availableFrom,
              availableUntil: availableUntil,
              mobile: prov.phoneNumber || '',
              hasAssignment: !!prov.assignedRsvp
            })
          })

          VueApp.$store.commit('provider/setAvailabilityList', provs)
        }
        self.getNoShift(VueApp, param, callback)
        return
      }
      callback(res)
    })
  },
  getNoShift (VueApp, param, callback) {
    let provider = VueApp.$store.state.provider
    let availability = provider.availability

    param.since = moment().set({hour: 0, minute: 0, second: 0}).format('X')
    param.until = moment().set({hour: 23, minute: 59, second: 59}).format('X')

    if (availability.noShift.list.length) return callback()

    VueApp.$sdk.get('/shifts/noshift', param, res => {
      let noShift = []
      if (!res.error) {
        if (res.noshift.length) {
          res.noshift.forEach(function (prov) {
            let name = prov.businessName || `${prov.firstName} ${prov.lastName}`
            let paxDtd = ''
            if (prov.supportPax) paxDtd = 'PAX'
            if (prov.supportDTD) paxDtd = 'DTD'
            if (prov.supportPax && prov.supportDTD) paxDtd = 'PAX/DTD'

            noShift.push({
              id: prov.ID,
              name: name || '--',
              firstName: prov.firstName,
              lastName: prov.lastName,
              licenseType: prov.accountType || '',
              homeSector: prov.homeSectorName || '',
              paxDtd: paxDtd,
              vehicleType: prov.vehicleType || '',
              mobile: prov.phoneNumber || ''
            })
          })

          let fieldSort = 'name'
          if (availability.noShift.order === 'license') fieldSort = 'licenseType'
          if (availability.noShift.order === 'sector') fieldSort = 'homeSector'
          if (availability.noShift.order === 'vehicle') fieldSort = 'vehicleType'

          if (availability.noShift.orderAsc == 1) noShift.sort((a, b) => a[fieldSort].toLowerCase().localeCompare(b[fieldSort].toLowerCase()))
          else noShift.sort((a, b) => b[fieldSort].toLowerCase().localeCompare(a[fieldSort].toLowerCase()))
        }
        VueApp.$store.commit('provider/setAvailabilityNoShiftData', {
          maxList: noShift.length,
          list: noShift,
          currentPage: 1
        })
      }

      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/availability.js